import { getAuth } from 'firebase/auth';
import { useCallback, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { showErrorDialog } from 'v3/data/store/error/actions';
import { setPreferenceOptionList } from 'v3/data/store/preferenceOptions/actions';
import { setStoreLogged } from 'v3/data/store/stores/actions';
import * as api from 'v3/services/api';
import { BetaAccessError } from 'v3/shared/components/Error/BetaError';
import { ConnectionError } from 'v3/shared/components/Error/ConnectionError';
import { GenericError } from 'v3/shared/components/Error/GenericError';
import { SnackBar } from 'v3/shared/components/SnackBar';
import { FeatureFlagEnum } from 'v3/shared/enums/feature-flag.enum';
import { AppStyles } from 'v3/styles/app-styles';

export const App: React.FC = () => {
  const getLoggedStore = useCallback(async () => {
    try {
      const flagResponse = await api.getFlagStatus(FeatureFlagEnum.IKB2C_4692_STORE_GROUPS_IMPROVEMENT);
      const loggedUser = getAuth().currentUser;

      if (flagResponse.data.enabled) {
        const storeResponse = await api.getStoreData(loggedUser!.uid);
        const { profile, ...storeData } = storeResponse.data;
        return setStoreLogged({ group: profile, ...storeData });
      }

      const response = await api.getStoreUserAccount({ email: loggedUser?.email, storeUserId: loggedUser?.uid });
      setStoreLogged(response.data);
    } catch (error) {
      showErrorDialog('Erro ao obter dados da conta', error);
    }
  }, []);

  useEffect(() => {
    getLoggedStore();
  }, [getLoggedStore]);

  const fetchPreferenceOptions = async () => {
    const preferences = await api.getPreferenceOptions();
    return setPreferenceOptionList(preferences.data);
  };

  useEffect(() => {
    fetchPreferenceOptions();
  }, []);

  return (
    <AppStyles>
      <SnackBar />
      <ConnectionError />
      <GenericError />
      <BetaAccessError />
      <Outlet />
    </AppStyles>
  );
};
